import { IUpdateVersionLaridaeAction } from '../actions/pdfDownloadLinkReporteLaridaeActions';

interface ILaridaeVersionState {
  version?: string;
}

const initialState: ILaridaeVersionState = {
}


export function pdfDownloadLinkReporteLaridaeReducer(state = initialState, {type, ...other}: IUpdateVersionLaridaeAction): ILaridaeVersionState {
  switch (type) {
    case 'UPDATE_VERSION_LARIDAE_PARA_PDF': 
      return {...state, version: other.versionLaridae}
    default:
      return state;
  }
}